import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Qué recibiré exactamente al comprar?',
    a: 'Recibirás acceso inmediato al ebook completo (132 páginas en PDF), con los 16 capítulos, el plan de 21 días, los menús semanales, las 15 recetas express, el diario de síntomas imprimible, el glosario y todos los anexos. Todo descargable y tuyo para siempre.'
  }, {
    q: '¿Cómo accedo al contenido?',
    a: 'Después de completar tu compra, recibirás un enlace de acceso a tu guía digital para descargarla y guardarla en tu móvil, tablet u ordenador.'
  }, {
    q: '¿Es un ebook físico o digital?',
    a: 'Es 100% digital. No hay envío físico. Podrás leerlo y consultarlo desde cualquier dispositivo siempre que quieras.'
  }, {
    q: '¿Cuánto tiempo tengo para pedir la devolución?',
    a: 'Tienes hasta 7 días desde tu compra para solicitar la devolución según las condiciones indicadas, sin preguntas incómodas.'
  }, {
    q: '¿Este ebook sustituye atención médica?',
    a: 'No. Esta guía es un recurso educativo e informativo. No sustituye diagnóstico, tratamiento ni consejo médico profesional. Si tienes una condición de salud, consulta siempre con tu profesional de confianza.'
  }, {
    q: '¿Puedo seguirlo si estoy empezando desde cero?',
    a: 'Sí. La guía está pensada para mujeres que parten de cero. Cada paso está explicado de forma clara, sencilla y aplicable desde el primer día.'
  }, {
    q: '¿Necesito seguir una dieta estricta?',
    a: 'No. La guía propone un enfoque integral y flexible basado en la regla del 80/20, pensado para ser sostenible en la vida real.'
  }, {
    q: '¿Las recetas son complicadas?',
    a: 'No. Son recetas rápidas, con ingredientes accesibles y pasos sencillos. La mayoría se preparan en menos de 20 minutos.'
  }, {
    q: '¿Necesito experiencia previa con este tipo de alimentación?',
    a: 'Para nada. Está pensada para acompañarte desde el primer día, sin importar tu punto de partida.'
  }, {
    q: '¿Necesito suplementos obligatoriamente?',
    a: 'No. La guía se centra en alimentación, hábitos y estilo de vida. Los suplementos se mencionan solo como información complementaria.'
  }, {
    q: '¿Está pensado solo para mujeres?',
    a: 'El enfoque, el lenguaje y los contenidos hormonales están especialmente diseñados para mujeres, aunque los principios antiinflamatorios pueden aplicarse a cualquier persona.'
  }];
  // First FAQ open by default to reduce initial friction
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full px-4 py-20 bg-cream" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-44">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-ink mb-6" data-id="element-45">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-46">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.04
        }} className="bg-ivory border border-taupe/20 rounded-2xl overflow-hidden" data-id="element-47">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-48">
                <span className="font-serif text-lg md:text-xl text-ink font-medium pr-4" data-id="element-49">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-clay shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-50" />
              </button>
              <AnimatePresence initial={false} data-id="element-51">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-52">
                    <div className="px-6 pb-5 text-ink/80 leading-relaxed" data-id="element-53">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}